import { render } from "./base-tabs.vue?vue&type=template&id=4b483e98"
const script = {}

import "./base-tabs.vue?vue&type=style&index=0&id=4b483e98&lang=scss"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__